import { useContext, useMemo } from 'react';

import { DefaultImageIcon, Tooltip } from '@smartshell/ui-kit';
import cn from 'classnames';
import dayjs from 'dayjs';
import DOMPurify from 'dompurify';
import { Column } from 'react-table';

import { LocalizationContext } from 'localization';
import { ICompanyNewsList } from 'schemas';

import s from '../News.module.scss';

export const useColumns = (): Column<ICompanyNewsList>[] => {
  const { t } = useContext(LocalizationContext);

  return useMemo(
    () => [
      {
        Header: '',
        id: 'image',
        accessor: ({ image }) => (!image ? false : image),
        Cell: ({ value }: { value: string }) => {
          return (
            <div className={s.column_img_block}>
              {value ? (
                <Tooltip
                  className={s.column_img_tooltip}
                  contentClassName={s.column_img_content}
                  content={<img alt="food-icon" src={value} />}
                  position={'bottom-left'}
                >
                  <img alt="food-icon" className={s.column_img} src={value} />
                </Tooltip>
              ) : (
                <DefaultImageIcon color={'secondary'} />
              )}
            </div>
          );
        },
        width: 80,
      },
      {
        Header: t('news.manager.name.title'),
        accessor: 'title',
        width: 330,
      },

      {
        Header: t('begin.period'),
        id: 'publication_period_from',
        accessor: ({ publication_period }) =>
          publication_period?.from
            ? dayjs(publication_period.from).format('DD.MM.YYYY HH:mm')
            : '—',
        width: 158,
      },
      {
        Header: t('end.period'),
        id: 'publication_period_until',
        accessor: ({ publication_period }) =>
          publication_period?.until
            ? dayjs(publication_period.until).format('DD.MM.YYYY HH:mm')
            : '—',
        width: 158,
      },
      {
        Header: t('mews.table.button.text'),
        id: 'link',
        accessor: ({ link }) => link || false,
        Cell: ({ value }: { value: { label: string; url: string } }) => {
          return (
            <div className={cn(s.link, !value && s.empty)}>
              <span className={s.text}>{value ? value.label : t('no')}</span>
            </div>
          );
        },
        width: 267,
      },
      {
        Header: t('news.text'),
        id: 'content',
        accessor: 'content',
        Cell: ({ value }: { value: string }) => {
          const cleanHtml = DOMPurify.sanitize(value);

          return (
            <div className={cn(s.content)}>
              <div
                className={s.text}
                dangerouslySetInnerHTML={{ __html: cleanHtml }}
              />
            </div>
          );
        },

        width: 481,
      },
      {
        Header: t('createdAt'),
        id: 'createdAt',
        accessor: 'created_at',
        Cell: ({ value }: { value: string }) =>
          dayjs(value).format('DD.MM.YYYY HH:mm'),
        width: 158,
      },
    ],
    [t]
  );
};
